import { render, staticRenderFns } from "./doneReadOnly.vue?vue&type=template&id=2c1d219c&scoped=true&"
import script from "./doneReadOnly.vue?vue&type=script&lang=js&"
export * from "./doneReadOnly.vue?vue&type=script&lang=js&"
import style0 from "./doneReadOnly.vue?vue&type=style&index=0&id=2c1d219c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1d219c",
  null
  
)

export default component.exports